import { render } from "./Pagos.vue?vue&type=template&id=43f95804"
import script from "./Pagos.vue?vue&type=script&lang=js"
export * from "./Pagos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/AccesoGanaderos/Pagos.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43f95804"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43f95804', __exports__)) {
    api.reload('43f95804', __exports__)
  }
  
  module.hot.accept("./Pagos.vue?vue&type=template&id=43f95804", () => {
    api.rerender('43f95804', render)
  })

}


export default __exports__